import React, { useState } from "react";
import {
  Flex,
  Heading,
  Input,
  List,
  ListItem,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DrawerBody,
  Button,
  VStack,
} from "@chakra-ui/react";
import { TrendingDown, TrendingUp } from "lucide-react";
import useCustomTheme from "../../hooks/useCustomTheme";

const initialCurrencyData = [
  { name: "Euro", iso: "EUR", symbol: "€", rate: 1.0, flag: "🇪🇺", trend: "up" },
  { name: "US Dollar", iso: "USD", symbol: "$", rate: 1.0893, flag: "🇺🇸", trend: "down" },
  { name: "Pound Sterling", iso: "GBP", symbol: "£", rate: 0.8839, flag: "🇬🇧", trend: "up" },
  { name: "Yen", iso: "JPY", symbol: "¥", rate: 141.4135, flag: "🇯🇵", trend: "down" },
  { name: "Yuan", iso: "CNY", symbol: "¥", rate: 7.3428, flag: "🇨🇳", trend: "down" },
  { name: "Won", iso: "KRW", symbol: "₩", rate: 1507.64, flag: "🇰🇷", trend: "down" },


];

const CurrencyConverterDrawer = ({ isOpen, onClose }) => {
  const [currencies, setCurrencies] = useState(initialCurrencyData);
  const { theme } = useCustomTheme();
  
  const handleRateChange = (value, index) => {
    const baseRate = parseFloat(value);
    if (isNaN(baseRate)) return;

    const updatedCurrencies = currencies.map((currency, i) => {
      if (i === index) {
        return { ...currency, rate: baseRate };
      } else {
        const newRate = (currency.rate / currencies[index].rate) * baseRate;
        return { ...currency, rate: newRate };
      }
    });

    setCurrencies(updatedCurrencies);
  };

  const handleBlur = () => {
    const updatedCurrencies = currencies.map((currency) => ({
      ...currency,
      rate: parseFloat(currency.rate).toFixed(2),
    }));
    setCurrencies(updatedCurrencies);
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="sm">
      <DrawerOverlay />
      <DrawerContent bg="grey.800">
        <DrawerCloseButton color="white" onClick={onClose} zIndex={1}/>
        <DrawerHeader color="white" fontSize="lg" fontWeight="bold">
          Currency Converter
        </DrawerHeader>
        
        <DrawerBody>
          <List spacing={1}
            
          >
            {currencies.map((currency, index) => (
              <ListItem
                key={currency.name}
                display="flex"
                justifyContent="space-between"
                align="center"
                py={4}
                px={4}
                bg={"grey.900"}
                borderRadius={8}
              >
                <Flex align="center" gap={3}>
                  <Text fontSize="3xl">{currency.flag}</Text>
                  <VStack spacing={0} align={"start"}>
                  <Heading fontSize="md" fontWeight="500" color="white">
                    {currency.iso}
                  </Heading>
                  <Text fontSize="xs" fontWeight="500" >
                    {currency.name}
                  </Text>
                  </VStack>
                </Flex>

                <Flex align="center" gap={2}>
                  <Input
                    type="number"
                    size="sm"
                    border="none"
                    value={currency.rate}
                    onChange={(e) => handleRateChange(e.target.value, index)}
                    onBlur={handleBlur}
                    width="160px"
                    textAlign="right"
                    color="white"
                    fontSize={"xl"}
                  />
                  {currency.trend === "up" ? (
                    <TrendingUp color={theme.colors.success[700]} size={16} />
                  ) : (
                    <TrendingDown color={theme.colors.error[700]} size={16} />
                  )}
                </Flex>
              </ListItem>
            ))}
          
          </List>
          <Button
            mt={8}
              variant="outline"
              size="sm"
              color={"white"}
            >Add currency</Button>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default CurrencyConverterDrawer;
